var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUtilizeOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4835 54.3736L34.1212 44.2004C35.7627 42.4679 38.4242 42.4679 40.0656 44.2004L46.7311 51.2363C48.3725 52.9689 51.0341 52.9689 52.6755 51.2363L66.5165 36.6263M66.5165 36.6263V47.7184M66.5165 36.6263H56.0082",
    stroke: "#3BB1E6",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88 45.5C88 65.5345 88 75.5522 81.7759 81.7759C75.5522 88 65.5345 88 45.5 88C25.4653 88 15.448 88 9.224 81.7759C3 75.5522 3 65.5345 3 45.5C3 25.4653 3 15.448 9.224 9.224C15.448 3 25.4653 3 45.5 3C65.5345 3 75.5522 3 81.7759 9.224C85.9145 13.3624 87.3013 19.1778 87.7658 28.5",
    stroke: "#3BB1E6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 45.5C88 65.5345 88 75.5522 81.7759 81.7759C75.5522 88 65.5345 88 45.5 88C25.4653 88 15.448 88 9.224 81.7759C3 75.5522 3 65.5345 3 45.5C3 25.4653 3 15.448 9.224 9.224C15.448 3 25.4653 3 45.5 3C65.5345 3 75.5522 3 81.7759 9.224C85.9145 13.3624 87.3013 19.1778 87.7658 28.5",
    stroke: "#3BB1E6",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilizeOne);
export default __webpack_public_path__ + "static/media/utilize-one.765bd5ca162d67794014938bc617c315.svg";
export { ForwardRef as ReactComponent };